import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6383e4de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questions-container" }
const _hoisted_2 = { class: "question-primary-language" }
const _hoisted_3 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_4 = {
  key: 0,
  class: "response-container grid-1x2 w-100"
}
const _hoisted_5 = { class: "align-items-center no-padding display-grid" }
const _hoisted_6 = { class: "option-primary-language no-padding" }
const _hoisted_7 = { class: "no-padding text-start" }
const _hoisted_8 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_9 = { class: "no-padding text-start" }
const _hoisted_10 = {
  key: 1,
  class: "response-container grid-2x2 w-100"
}
const _hoisted_11 = { class: "no-padding display-grid" }
const _hoisted_12 = { class: "option-primary-language no-padding" }
const _hoisted_13 = { class: "no-padding text-start" }
const _hoisted_14 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_15 = { class: "no-padding text-start" }
const _hoisted_16 = { class: "align-items-center no-padding display-grid" }
const _hoisted_17 = { class: "option-primary-language no-padding" }
const _hoisted_18 = { class: "no-padding text-start" }
const _hoisted_19 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_20 = { class: "no-padding text-start" }
const _hoisted_21 = { class: "align-items-center justify no-padding display-grid" }
const _hoisted_22 = { class: "option-primary-language no-padding" }
const _hoisted_23 = { class: "no-padding text-start" }
const _hoisted_24 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_25 = { class: "no-padding text-start" }
const _hoisted_26 = { class: "align-items-center no-padding display-grid" }
const _hoisted_27 = { class: "option-primary-language no-padding" }
const _hoisted_28 = { class: "no-padding text-start" }
const _hoisted_29 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_30 = { class: "no-padding text-start" }
const _hoisted_31 = {
  key: 2,
  class: "response-container grid-2x3 w-100"
}
const _hoisted_32 = { class: "no-padding display-grid" }
const _hoisted_33 = { class: "option-primary-language no-padding" }
const _hoisted_34 = { class: "no-padding text-start" }
const _hoisted_35 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_36 = { class: "no-padding text-start" }
const _hoisted_37 = { class: "align-items-center no-padding display-grid" }
const _hoisted_38 = { class: "option-primary-language no-padding" }
const _hoisted_39 = { class: "no-padding text-start" }
const _hoisted_40 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_41 = { class: "no-padding text-start" }
const _hoisted_42 = { class: "align-items-center justify no-padding display-grid" }
const _hoisted_43 = { class: "option-primary-language no-padding" }
const _hoisted_44 = { class: "no-padding text-start" }
const _hoisted_45 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_46 = { class: "no-padding text-start" }
const _hoisted_47 = { class: "align-items-center no-padding display-grid" }
const _hoisted_48 = { class: "option-primary-language no-padding" }
const _hoisted_49 = { class: "no-padding text-start" }
const _hoisted_50 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_51 = { class: "no-padding text-start" }
const _hoisted_52 = { class: "align-items-center no-padding display-grid" }
const _hoisted_53 = { class: "option-primary-language no-padding" }
const _hoisted_54 = { class: "no-padding text-start" }
const _hoisted_55 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_56 = { class: "no-padding text-start" }
const _hoisted_57 = { class: "align-items-center no-padding display-grid" }
const _hoisted_58 = { class: "option-primary-language no-padding" }
const _hoisted_59 = { class: "no-padding text-start" }
const _hoisted_60 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_61 = { class: "no-padding text-start" }
const _hoisted_62 = {
  key: 3,
  class: "response-container grid-2x4 w-100"
}
const _hoisted_63 = { class: "no-padding display-grid" }
const _hoisted_64 = { class: "option-primary-language no-padding" }
const _hoisted_65 = { class: "no-padding text-start" }
const _hoisted_66 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_67 = { class: "no-padding text-start" }
const _hoisted_68 = { class: "align-items-center no-padding display-grid" }
const _hoisted_69 = { class: "option-primary-language no-padding" }
const _hoisted_70 = { class: "no-padding text-start" }
const _hoisted_71 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_72 = { class: "no-padding text-start" }
const _hoisted_73 = { class: "align-items-center justify no-padding display-grid" }
const _hoisted_74 = { class: "option-primary-language no-padding" }
const _hoisted_75 = { class: "no-padding text-start" }
const _hoisted_76 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_77 = { class: "no-padding text-start" }
const _hoisted_78 = { class: "align-items-center no-padding display-grid" }
const _hoisted_79 = { class: "option-primary-language no-padding" }
const _hoisted_80 = { class: "no-padding text-start" }
const _hoisted_81 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_82 = { class: "no-padding text-start" }
const _hoisted_83 = { class: "align-items-center no-padding display-grid" }
const _hoisted_84 = { class: "option-primary-language no-padding" }
const _hoisted_85 = { class: "no-padding text-start" }
const _hoisted_86 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_87 = { class: "no-padding text-start" }
const _hoisted_88 = { class: "align-items-center no-padding display-grid" }
const _hoisted_89 = { class: "option-primary-language no-padding" }
const _hoisted_90 = { class: "no-padding text-start" }
const _hoisted_91 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_92 = { class: "no-padding text-start" }
const _hoisted_93 = { class: "align-items-center no-padding display-grid" }
const _hoisted_94 = { class: "option-primary-language no-padding" }
const _hoisted_95 = { class: "no-padding text-start" }
const _hoisted_96 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_97 = { class: "no-padding text-start" }
const _hoisted_98 = { class: "align-items-center no-padding display-grid" }
const _hoisted_99 = { class: "option-primary-language no-padding" }
const _hoisted_100 = { class: "no-padding text-start" }
const _hoisted_101 = {
  key: 0,
  class: "option-secondary-language"
}
const _hoisted_102 = { class: "no-padding text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-item-container", { 'first-form-item': _ctx.form_item_order === 0 && _ctx.layout_mode === 'all_on_one_page' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.options.length === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["option-container no-padding", { 'clicked': _ctx.clickedOption === 0 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleOptionClick(0)))
          }, null, 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 1 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleOptionClick(1)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.options[1].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.options[1].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.options.length === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 0 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleOptionClick(0)))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.options[0].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.options[0].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 1 }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleOptionClick(1)))
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.options[1].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.options[1].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 2 }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOptionClick(2)))
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.options[2].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.options[2].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 3 }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleOptionClick(3)))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.options[3].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.options[3].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.options.length === 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 0 }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOptionClick(0)))
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.options[0].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.options[0].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 1 }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleOptionClick(1)))
          }, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.options[1].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.options[1].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 2 }]),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleOptionClick(2)))
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.options[2].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.options[2].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 3 }]),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleOptionClick(3)))
          }, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.options[3].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.options[3].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 4 }]),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleOptionClick(4)))
          }, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.options[4].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.options[4].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 5 }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleOptionClick(5)))
          }, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.options[5].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.options[5].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.options.length === 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 0 }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleOptionClick(0)))
          }, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.options[0].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.options[0].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 1 }]),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleOptionClick(1)))
          }, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.options[1].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.options[1].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 2 }]),
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleOptionClick(2)))
          }, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.options[2].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.options[2].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 3 }]),
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleOptionClick(3)))
          }, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.options[3].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.options[3].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 4 }]),
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleOptionClick(4)))
          }, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.options[4].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.options[4].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 5 }]),
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleOptionClick(5)))
          }, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.options[5].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.options[5].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 6 }]),
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleOptionClick(6)))
          }, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.options[6].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.options[6].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["option-container padding", { 'clicked': _ctx.clickedOption === 7 }]),
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleOptionClick(7)))
          }, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.options[7].text_lang1), 1)
              ]),
              (_ctx.bilingue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.options[7].text_lang2), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}